import { Suspense } from 'react';
import styled from 'styled-components';

import Navigation from "./../components/Navigation";
import SponsorLoggor from "./../images/Loggor2026.png";
import KulturLogga from "./../images/Krogbacken_logo.png";
import SEO from "./../components/SEO";
import { useLanguage } from "../i18n";
import { useContent } from "../i18n/useContent";

const Main = styled.main`
    margin: 0 auto;
    max-width: 1100px;
`;

const Article = styled.article`
    h1, h2 {
        color: #825c26;
    }

    ul {
        margin-top: 0;
    }

    footer {
        text-align: center;
    }
`;

const Header = styled.header`
    margin-top: 1.5rem;
    h1 {
        font-size: 3rem;
        text-align: center;
        line-height: 2.8rem;
    }
`;

const BreadText = styled.div`
    margin: 1rem;

    p {
        margin-top: 0;
    }

    @media screen and (min-width: 600px) {
        margin-left: 10%;
        margin-right: 10%;
    }

    @media screen and (min-width: 800px) {

        column-count: 2;
        column-span: all;
        column-gap: 2rem;
    }
`;

const SponsorPaket = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media screen and (min-width: 950px) {
        flex-direction: row;
        align-items: stretch;
        justify-content: space-around;
    }

    section {
        border: solid 3px rgba(130,92,38,0.6);
        border-radius: 12px;
        padding: 1rem 3rem 0.5rem 3rem;
        display: flex;
        justify-content: center;
        line-height: 1.4rem;
        margin: 1rem 0;
        line-height: 2rem;

        h2 {
            text-align: left;
            margin: 0.5rem 0;
        }
    }
`;

const Logos = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 400px;
    margin-left: auto;
    margin-right: auto;

    @media screen and (max-width: 500px) {
        flex-direction: column;
    }

    div {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
    }
`;


const SponsorBild = styled.img`
    width: 102px;

    @media screen and (min-width: 500px) {
        width: 110px;
    }
`;

const KulturbackenLogo = styled.img`
    width: 150px;

    @media screen and (min-width: 500px) {
        width: 200px;
    }
`;



const Loggor = styled.div`
    display: flex;
    flex-direction: column;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    padding: 2rem 0 3rem 0;

    img {
        width: 100%;
    }

    @media screen and (min-width: 800px) {
        width: 70%;
    }
    @media screen and (min-width: 950px) {
        width: 60%;
    }
`;

const Sponsorer = () => {
    const { t } = useLanguage();
    const Content = useContent('sponsorer');

    return (
        <>
            <SEO pageKey="sponsorer" />
            <Main>
                <Navigation page="sponsorer" />
                <Article>
                    <Header><h1>{t('sponsorer.title')}</h1></Header>
                    <Loggor>
                        <SponsorBild src={SponsorLoggor} />
                    </Loggor>
                </Article>
                <Article>
                    <Header><h1>{t('sponsorer.becomeTitle')}</h1></Header>
                    <BreadText>
                        <Suspense fallback={<div>...</div>}>
                            <Content />
                        </Suspense>
                    </BreadText>

                    <SponsorPaket>
                        <section>
                            <div>
                                <h2>{t('sponsorer.packageTitle')}</h2>
                                {t('sponsorer.price')}<br />
                                {t('sponsorer.asSponsors')}
                                <ul>
                                    <li>{t('sponsorer.benefit1')}</li>
                                    <li>{t('sponsorer.benefit2')}</li>
                                    <li>{t('sponsorer.benefit3')}</li>
                                    <li>{t('sponsorer.benefit4')}</li>
                                </ul>
                            </div>
                        </section>
                    </SponsorPaket>

                    <footer>
                        <p>{t('sponsorer.organizedByText')}</p>
                        <Logos>
                            <div>
                                {t('sponsorer.foreningenKultur')}<br />{t('sponsorer.kulturPaKrogbacken')}
                            </div>

                            <div>
                                <KulturbackenLogo src={KulturLogga} />
                            </div>
                        </Logos>
                    </footer>

                </Article>
            </Main>
        </>
    )
}

export default Sponsorer;
